import { render, staticRenderFns } from "./xmlToJson.vue?vue&type=template&id=8d3cd354&scoped=true&"
import script from "./xmlToJson.vue?vue&type=script&lang=js&"
export * from "./xmlToJson.vue?vue&type=script&lang=js&"
import style0 from "./xmlToJson.vue?vue&type=style&index=0&id=8d3cd354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3cd354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d3cd354')) {
      api.createRecord('8d3cd354', component.options)
    } else {
      api.reload('8d3cd354', component.options)
    }
    module.hot.accept("./xmlToJson.vue?vue&type=template&id=8d3cd354&scoped=true&", function () {
      api.rerender('8d3cd354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ui-document/components/xmlToJson.vue"
export default component.exports